import React from 'react'
import { CAlert, CButton } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilReload, cilWarning } from '@coreui/icons'

const LoadError = ({ message, onRetry, className = 'mb-0' }) => (
  <CAlert color="danger" className={`d-flex flex-wrap align-items-center gap-2 ${className}`}>
    <CIcon icon={cilWarning} className="flex-shrink-0" />
    <span>{message}</span>
    {onRetry && (
      <CButton color="danger" variant="outline" size="sm" className="ms-auto" onClick={onRetry}>
        <CIcon icon={cilReload} className="me-1" />
        Retry
      </CButton>
    )}
  </CAlert>
)

export default LoadError
